module.exports = __webpack_public_path__ + "static/media/reg_tabQRCode_hide.6bae45df.svg";